class FooterAccordion {
  constructor(container) {
    this.container = container;
    this.details = Array.from(container.querySelectorAll('[data-footer-details]'));
    this.desktopMediaQuery = window.matchMedia('(min-width: 990px)');
    this.onToggle = this.handleToggle.bind(this);
    this.onViewportChange = this.handleViewportChange.bind(this);

    if (!this.details.length) return;

    this.init();
  }

  init() {
    this.details.forEach((detail) => {
      detail.dataset.defaultOpen = detail.hasAttribute('open') ? 'true' : 'false';
      detail.addEventListener('toggle', this.onToggle);
      this.updateAccessibility(detail);
    });

    if (typeof this.desktopMediaQuery.addEventListener === 'function') {
      this.desktopMediaQuery.addEventListener('change', this.onViewportChange);
    } else {
      this.desktopMediaQuery.addListener(this.onViewportChange);
    }

    this.handleViewportChange();
  }

  destroy() {
    this.details.forEach((detail) => {
      detail.removeEventListener('toggle', this.onToggle);
    });

    if (typeof this.desktopMediaQuery.removeEventListener === 'function') {
      this.desktopMediaQuery.removeEventListener('change', this.onViewportChange);
    } else {
      this.desktopMediaQuery.removeListener(this.onViewportChange);
    }
  }

  handleViewportChange() {
    if (this.desktopMediaQuery.matches) {
      this.details.forEach((detail) => {
        detail.setAttribute('open', '');
        this.updateAccessibility(detail);
      });

      return;
    }

    this.details.forEach((detail) => {
      if (detail.dataset.defaultOpen === 'true') {
        detail.setAttribute('open', '');
      } else {
        detail.removeAttribute('open');
      }

      this.updateAccessibility(detail);
    });
  }

  handleToggle(event) {
    const currentDetail = event.currentTarget;
    this.updateAccessibility(currentDetail);

    if (this.desktopMediaQuery.matches || !currentDetail.open) return;

    this.details.forEach((detail) => {
      if (detail === currentDetail || !detail.open) return;

      detail.removeAttribute('open');
      this.updateAccessibility(detail);
    });
  }

  updateAccessibility(detail) {
    const summary = detail.querySelector('[data-footer-summary]');
    if (!summary) return;

    summary.setAttribute('aria-expanded', detail.hasAttribute('open') ? 'true' : 'false');
  }
}

const footerAccordionInstances = new WeakMap();

function initFooterAccordions(container = document) {
  container.querySelectorAll('[data-footer-accordion]').forEach((footerAccordion) => {
    if (footerAccordionInstances.has(footerAccordion)) return;

    footerAccordionInstances.set(footerAccordion, new FooterAccordion(footerAccordion));
  });
}

function destroyFooterAccordions(container) {
  container.querySelectorAll('[data-footer-accordion]').forEach((footerAccordion) => {
    const instance = footerAccordionInstances.get(footerAccordion);
    if (!instance) return;

    instance.destroy();
    footerAccordionInstances.delete(footerAccordion);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initFooterAccordions());
} else {
  initFooterAccordions();
}

document.addEventListener('shopify:section:load', (event) => {
  initFooterAccordions(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  destroyFooterAccordions(event.target);
});
